export default {
    modelValue: {
        type: Boolean,
        default: undefined
    },
    checked: {
        type: Boolean,
        default: undefined
    }, 
    enabled: {
        type: Boolean,
        default: undefined
    }, 
    readonly: {
        type: Boolean,
        default: undefined
    }, 
    messages: {
        type: Object,
        default: undefined
    }, 
    width: {
        type: [Number, String],
        default: undefined
    }, 

    // Events
    change: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSwitch/SwitchProps.js